export const WalletCheckoutSteps = {
  LOADING: 'LOADING',
  OPEN_POPUP: 'OPEN_POPUP',
  REQUEST_ACCESS: 'REQUEST_ACCESS',
  LOGIN: 'LOGIN',
  OTP: 'OTP',
  SELECT_ACCOUNT: 'SELECT_ACCOUNT',
  PREVIEW: 'PREVIEW'
} as const
